import React from 'react';
import {connect} from 'react-redux';
import {
    ActionDescriptorsTenderTypes, ActionPlanTypesDelete,
    ActionTenderTypesAdd,
    ActionTenderTypesDelete,
    ActionTenderTypesEdit
} from "../../../parts/actions";
import ColumnResizer from "react-column-resizer";
import Storege from "../../../storage/storage";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import TenderTypesPopup from "./TenderTypesPopup";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import EditBtn from "../../../parts/EditBtn";

class TenderTypesDescriptorComponent extends CommonTab {

    orderFields = {
        "Tender Type Name" : "tendertypename",
        "Tender Type Name Eng": "tendertypenameeng"
    };

    state = {
        tendersTypese: {},
        popup: false,
        popupType: undefined,
        rowIndex: -1,
        currentItemIndex: -1,
        filteredItems: [],
        order: null
    };

    constructor(props) {
        super(props);
        this.state.tendersTypes = props.tendersTypes;
    }

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    addContentType = (object) => {
        console.log(object);
        ActionTenderTypesAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD TENDER TYPE',
                item: data
            });
            this.changePopupState();
        });
    };

    editContentType = (object) => {
        console.log(object);
        ActionTenderTypesEdit(object.tendertypeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE TENDER TYPE',
                item: data,
                id: data.tendertypeid
            });
            this.changePopupState();
        });
    };

    changeState = (name, e, id) => {
        let temp = this.props.tendersTypes;
        temp.forEach(function (item) {
            if (item.tendertypeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            tendersTypes: Object.assign({}, temp)
        });
    };

    search = (value) => {
        if (value.length) {
            let filteredArray = this.props.tendersTypes.filter(item => {
                return item.tendertypename.toLowerCase().indexOf(value.toLowerCase()) != -1 || item.tendertypenameeng.toLowerCase().indexOf(value.toLowerCase()) != -1;
            });
            this.setState({
                filtered: true,
                filteredItems: filteredArray
            });
        } else {
            this.setState({
                filtered: false
            });
        }
    };

    render() {
        if (!this.props.tendersTypes.length) {
            ActionDescriptorsTenderTypes();
        }
        let {filtered, filteredItems} = this.state;
        let {tendersTypes} = this.props;
        let list = filtered ? filteredItems : tendersTypes;
        if (!list) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        this.sortResults(list);

        return (
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div className="inline-toolbuttons">
                            <h3>Tender Types:</h3>
                            <div className={'tool-bar tender-bar'}>
                                <Search
                                    change={this.search}
                                />
                                <ToolButtons
                                    actionType={this.changePopupType}
                                    popupChange={this.changePopupState}
                                    id={this.state.currentItemIndex}
                                />
                                <Search
                                    change={this.search}
                                />
                            </div>
                        </div>
                        <table className='table table-striped'>
                            <thead>
                            {this.orderPanel()}
                            </thead>
                            <tbody>
                            {(list ? list : []).map((item, index) => {
                                return (
                                    <tr key={index} onClick={
                                        e => {
                                            e.preventDefault();
                                            this.setState({
                                                rowIndex: index,
                                                currentItemIndex: item.tendertypeid
                                            });
                                        }
                                    } className={this.state.rowIndex == index ? 'active' : ''}>
                                        <td className={'flex-row'}>
                                            <RemoveButton
                                                action={ActionTenderTypesDelete}
                                                id={item.tendertypeid}
                                                descriptor={'REMOVE TENDER TYPE'}
                                            />
                                            <EditBtn
                                                actionType={this.changePopupType}
                                                popupChange={this.changePopupState}
                                                change={this.setCurrentIndex}
                                                id={item.tendertypeid}
                                            />
                                        </td>
                                        <td>{item.tendertypename}</td>
                                        <ColumnResizer className="columnResizer" minWidth={5} />
                                        <td>{item.tendertypenameeng}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.popup ? <TenderTypesPopup
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        tendersTypes: state.tendersTypes
    }
};
const DescriptorTenderTypes = connect(mapStateToProps)(TenderTypesDescriptorComponent);

export default DescriptorTenderTypes;